function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../locales/keys';
import { MetadataConstants, MetadataSelectors } from 'invision-core';
import { CUSTOMER_CATEGORY } from '../../createCustomerPopup/create.customer.popup.constants';
import { SelectedCustomerCategorySelector } from '../../../reducers/selectors/customer.selectors';
import { REGEXES } from '../../../customercare.constants';
var PHONE_NUMBER_FIELD_MAX_LENGTH = 20;
var ContactInformationSectionController = /*#__PURE__*/function () {
  function ContactInformationSectionController($ngRedux) {
    _classCallCheck(this, ContactInformationSectionController);
    this.$ngRedux = $ngRedux;
    this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
  }
  return _createClass(ContactInformationSectionController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          contactMethodTypes: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.ContactMethod, store),
          customerCategory: SelectedCustomerCategorySelector(store),
          subscriberCategoryRequirements: MetadataSelectors.codes.SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberRequirements: MetadataSelectors.codes.SubscriberRequirementsForCurrentBusinessUnitOrDefault(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget)(function (state) {
        _this.state = state;
      });
      this.phoneNumberRegex = REGEXES.PHONE_NUMBER;
      this.phoneNumberFieldMaxLength = PHONE_NUMBER_FIELD_MAX_LENGTH;
      this.requirements = this.state.customerCategory === CUSTOMER_CATEGORY.COMMERCIAL ? this.state.subscriberCategoryRequirements : this.state.subscriberRequirements;
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.onFormChanged()(this.customerModel);
    }
  }, {
    key: "isShowHeader",
    value: function isShowHeader() {
      return !!(this.state.subscriberRequirements.display_business_phone || this.state.subscriberRequirements.display_home_phone || this.state.subscriberRequirements.display_mobile_phone);
    }
  }, {
    key: "isError",
    value: function isError(elementName) {
      var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var formElement = this.parentForm[elementName];
      var isError = false;
      if (formElement && (formElement.$touched || this.isFormSubmitted)) {
        if (fields.length === 0 && Object.keys(formElement.$error).length > 0) {
          isError = true;
        }
        fields.forEach(function (field) {
          if (formElement.$error[field]) {
            isError = true;
          }
        });
      }
      return isError;
    }
  }, {
    key: "isRequired",
    get: function get() {
      return this.removeMultiOfferValidations !== undefined ? !this.removeMultiOfferValidations : !this.overrideValidations;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./contact.information.section.html'),
  bindings: {
    customerModel: '<',
    errorLookup: '<',
    onFormChanged: '&',
    isFormSubmitted: '<',
    overrideValidations: '<?',
    removeMultiOfferValidations: '<?'
  },
  require: {
    parentForm: '^form'
  },
  controller: ContactInformationSectionController,
  controllerAs: 'ContactInformationSection'
};